import './IntentButton.css';
export var disabledAppIconOpacity = '_e0qchl0-2-0-1';